import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/User';
import { displayImg } from '../../utils/utils.functions';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
})
export class DefaultHeaderComponent implements OnInit {
  user: User;
  textButton = 'Se connecter';
  textHeader = 'Vous avez déjà un compte ?';
  constructor(private router: Router, public authService: AuthService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.textButton = router.url.includes('login')
          ? "S'inscrire"
          : 'Se connecter';
        this.textHeader = router.url.includes('login')
          ? "Vous n'avez pas encore de compte ?"
          : 'Vous avez déjà un compte ?';
      }
    });
    // this.textButton =  router.url.includes('register') ? "S'inscrire" : 'Se connecter'
  }

  onClick(): void {
    if (this.router.url.includes('login')) {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {
    if (this.router.url != '/login') {
      this.authService.getUser().subscribe((value) => {
        this.user = value;
      });
    }
  }

  protected readonly displayImg = displayImg;
}
